export let ConfirmationActionType = /*#__PURE__*/function (ConfirmationActionType) {
  ConfirmationActionType["NEW_USER_SET_PASSWORD"] = "NEW_USER_SET_PASSWORD";
  ConfirmationActionType["CONFIRM_EMAIL"] = "CONFIRM_EMAIL";
  ConfirmationActionType["RESET_PASSWORD"] = "RESET_PASSWORD";
  ConfirmationActionType["LOGIN_LINK"] = "LOGIN_LINK";
  ConfirmationActionType["TENANT_LOGIN_LINK"] = "TENANT_LOGIN_LINK";
  ConfirmationActionType["INVENTORY_LOGIN_LINK"] = "INVENTORY_LOGIN_LINK";
  ConfirmationActionType["DISTRIBUTION_SHIPPED"] = "DISTRIBUTION_SHIPPED";
  ConfirmationActionType["CUSTOM_INK_PRO_IMPERSONATE_EXTERNAL"] = "CUSTOM_INK_PRO_IMPERSONATE_EXTERNAL";
  ConfirmationActionType["SIGN_DYNAMIC_STORE_INVENTORY_CONTRACT"] = "SIGN_DYNAMIC_STORE_INVENTORY_CONTRACT";
  return ConfirmationActionType;
}({});